export function update<T>(changes: Partial<T>, object: T): T {
    return Object.assign({}, object, changes)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/ObjectHelper.ts